import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/surveys/edit/Page";

export const PATH = (id: number): string => `/vendors/settings/surveys/${id}`;

const SurveySetting: NextPage = () => (
	<>
		<NskHead title="アンケート編集" />
		<Component />
	</>
);

export default SurveySetting;
